import { Box, CircularProgress, Dialog, DialogActions, DialogContent } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import { useAppTheme } from '../../Providers/ThemeContext/ThemeContext'
import { Close } from "@mui/icons-material"

const OneModal = ({
    titleText,
    TitleIcon,
    children,
    FooterButtons,
    open,
    setOpen,
    fullWidth = false,
    maxWidth = "md",
    loading = false,
    onClose = false,
    height = 'false',
    width = 'false',
    titleSize = false,
    paddingZero = false,
    dado
}) => {
    const { theme } = useAppTheme()
    const color_white = theme.palette.one_primary.contrastText

    const handleClose = () => {
        const close = onClose ? onClose() : true
        if (close) {
            setOpen(false)
        }
    }

    let styleContent = { display: 'flex', justifyContent: 'center' }
    if (paddingZero) {
        styleContent.padding = '0'
    } else {
        styleContent.paddingTop = '15px'
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll={'paper'}
            PaperProps={{ sx: { backgroundColor: theme.palette.one_modal_backcolor, height, width } }}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
        >
            <Grid container
                sx={{
                    background: theme.palette.one_bar_gradient,
                    color: color_white,
                    minHeight: '41px',
                    textAlign: 'center',
                    alignItems: 'center'
                }} >
                <Grid xs={12} container sx={{ margin: 0, padding: 0, justifyContent: 'space-between', width: '100%' }}>
                    {TitleIcon &&
                        <Grid xs={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <TitleIcon />
                        </Grid>
                    }
                    <Grid xs sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: titleSize }}>
                        {titleText}
                    </Grid>
                    <Grid xs={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Close sx={{ cursor: 'pointer', ':hover': { fontSize: titleSize ? (titleSize + (titleSize * 0.70)) : '30px' } }} onClick={() => setOpen(false)} />
                    </Grid>
                </Grid>
            </Grid>
            <DialogContent
                dividers={true}
                style={styleContent}>
                {loading
                    ? <Box sx={{ display: 'flex', width: '390px', height: '260px', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress size={90} sx={{ color: theme.palette.one_primary.main }} />
                    </Box>
                    : children}
            </DialogContent>
            {FooterButtons &&
                <DialogActions>
                    <Grid container xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                        <FooterButtons />
                    </Grid>
                </DialogActions>
            }
        </Dialog>
    )
}

export default OneModal
